// Google Analytics 4 Enhanced Measurement Utilities

// Check if gtag is available
const isGtagAvailable = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

// Track page view with custom parameters
export const trackPageView = (pagePath, pageTitle) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: pageTitle,
  });
};

// Track product/item view (single item)
export const trackViewItem = (item) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'view_item', {
    currency: 'TRY',
    items: [{
      item_id: item.id,
      item_name: item.name,
      item_category: item.category,
      item_category2: item.subcategory || '',
      item_brand: item.brand || 'ELC Teknoloji',
      price: item.price || 0,
    }],
  });
};

// Track product list view (multiple items)
export const trackViewItemList = (listName, items) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'view_item_list', {
    item_list_id: listName.toLowerCase().replace(/\s+/g, '_'),
    item_list_name: listName,
    items: items.map((item, index) => ({
      item_id: item.id,
      item_name: item.name,
      item_category: item.category,
      item_brand: item.brand || 'ELC Teknoloji',
      index: index,
      price: item.price || 0,
    })),
  });
};

// Track product click
export const trackSelectItem = (listName, item, index) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'select_item', {
    item_list_id: listName.toLowerCase().replace(/\s+/g, '_'),
    item_list_name: listName,
    items: [{
      item_id: item.id,
      item_name: item.name,
      item_category: item.category,
      item_brand: item.brand || 'ELC Teknoloji',
      index: index,
      price: item.price || 0,
    }],
  });
};

// Track CTA button clicks
export const trackCtaClick = (ctaName, ctaLocation, destinationUrl) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'cta_click', {
    cta_name: ctaName,
    cta_location: ctaLocation,
    destination_url: destinationUrl,
  });
};

// Track contact form submission
export const trackContactFormSubmit = (formData) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'generate_lead', {
    currency: 'TRY',
    value: 100, // Estimated lead value
  });
  
  window.gtag('event', 'contact_form_submit', {
    form_location: 'contact_page',
    has_phone: !!formData.phone,
    has_company: !!formData.company,
  });
};

// Track carousel slide view
export const trackCarouselView = (slideName, slideIndex) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'carousel_view', {
    slide_name: slideName,
    slide_index: slideIndex,
  });
};

// Track outbound link clicks
export const trackOutboundLink = (url, linkText) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'click', {
    event_category: 'outbound',
    event_label: url,
    link_text: linkText,
    transport_type: 'beacon',
  });
};

// Track file downloads
export const trackDownload = (fileName, fileType) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'file_download', {
    file_name: fileName,
    file_extension: fileType,
  });
};

// Track search
export const trackSearch = (searchTerm) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'search', {
    search_term: searchTerm,
  });
};

// Track scroll depth
export const trackScrollDepth = (percentage, pagePath) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'scroll', {
    percent_scrolled: percentage,
    page_path: pagePath,
  });
};
